<template>
  <div>
    <v-row v-if="user.business_token">
      <v-col cols="12" md="12">
        <v-card class="white rounded-lg" >
          <v-card-title class="secondary--text">{{ title }}
            <v-spacer></v-spacer>
            <v-btn
                large
                depressed
                class="receipt rounded-lg float-left"
                color="success"
                @click="openPaymentDialog">پرداخت</v-btn>

          </v-card-title>
          <v-card-text>
            <m-datatable :show-filter-row="false" :headers="cols" :apiUrl="apiUrl" :filters.sync="filters"
                         ref="datatable" :show-select="true">
            </m-datatable>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-card class="white rounded-lg" >
          <v-card-title class="error white--text">کسب و کار فعال نیست
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-dialog class="rounded-lg" v-model="paymentDialog" scrollable max-width="600px">
        <v-card class="rounded-lg">
          <v-card-title class="secondary white--text mb-5">
            <v-img class="ml-5" src="/img/icons/pay_dark.svg" max-width="30" max-height="30"></v-img>
            روش پرداخت
          </v-card-title>
          <v-card-text>
            <v-simple-table>
              <tbody>
              <tr>
                <th :style="isXs ? 'font-size: x-small' : ''" colspan="2">مبلغ فاکتور</th>
                <td :style="isXs ? 'font-size: x-small' : ''">
                  <span>{{ pay_amount | toMoney }}</span>
                  تومان
                </td>
              </tr>
              <tr>
                <th :style="isXs ? 'font-size: x-small' : ''" class="mb-5">تخفیف</th>
                <td :style="isXs ? 'font-size: x-small' : ''">
                  <span>{{ discountAmount | toMoney }}</span>
                </td>
                <td class="d-flex" :style="isXs ? 'font-size: x-small' : ''">
                  <v-text-field placeholder="کد تخفیف" v-model="discountCode" class="rounded-lg"/>
                  <v-btn @click="verifyDiscountCode" depressed color="primary" class="rounded-lg mr-2 mt-1"
                  >اعمال
                  </v-btn>
                </td>
              </tr>
              <tr>
                <th :style="isXs ? 'font-size: x-small' : ''" colspan="2">مبلغ بعد از تخفیف</th>
                <td :style="isXs ? 'font-size: x-small' : ''">
                  <span>{{ afterDiscount() | toMoney }}</span>
                  تومان
                </td>
              </tr>
              <tr>
                <th :style="isXs ? 'font-size: xx-small' : ''">
                  <span v-if="isXs"> موجودی </span>
                  <span v-else> موجودی کیف پول شما </span>
                </th>
                <td class="success--text" :style="isXs ? 'font-size: x-small' : ''">
                  <span class="success--text">{{ user.wallet.balance | toMoney }}</span>
                  <span v-if="!isXs"> تومان </span>
                </td>
                <td :style="isXs ? 'font-size: x-small' : ''">
                  <v-switch
                      inset
                      v-model="payFromWallet"
                      :label="isXs ? 'پرداخت' : 'پرداخت از کیف پول'"
                      :disabled="user.wallet.balance == 0"
                  />
                </td>
              </tr>

              <tr>
                <th :style="isXs ? 'font-size: x-small' : ''" colspan="2">مبلغ باقیمانده</th>
                <td :style="isXs ? 'font-size: x-small' : ''">
                  <span>{{ getRemain() | toMoney }}</span>
                  تومان
                </td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="payBusinessAffiliateFactors" depressed class="rounded-lg success white--text w-100px">پرداخت</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import cart from "@/components/scomponents/Cart";
import UserSelect from "@/components/selects/UserSelect";
import Swal from "sweetalert2";


export default {
  name: "BusinessNotPaidOrders",
  mixins: [MFormMixin, formsMixin, FormsMixin],
  components: {
    UserSelect,
    cart
  },

  props: {
    id: {},
  },
  data() {
    return {
      printUrl: 'affiliate/factor/all',
      baseUrl: "affiliate/factorCreate",
      permissionBasename: "affiliate_factor",
      appendSlash: false,
      payFromWallet: false,
      hasList: false,
      discountCode: "",
      discountAmount: 0,
      no_edit_dialog: false,
      hasIdProp: true,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      isDefinable: false,
      pay_amount: 0,
      myClass: '',
      ss: null,
      PathLevels,
      VisitorLevels,
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      filters: {
        status: 'irs'
      },
      first: false,
      cols: [
        {
          text: "نام کسب و کار",
          value: "business.name",
        },
        {
          text: "نام مشتری",
          value: "customer_name",
        },
        {
          text: "تلفن",
          value: "phone",
        },
        {
          text: "آدرس",
          value: "address",
        },
        {
          text: "مبلغ ",
          value: "factor_price_sum",
          type: 'numeric',
          filterable: false
        },
        {
          text: "وضعیت",
          value: "status_display",
        },
      ],

    };
  },
  computed: {
    apiUrl() {
      return `affiliate/factor/all?businessToken=${this.user.business_token}`
    },
    pay_amount_calculate() {
      let pay_amount_sum = 0
      for (let factor of this.$refs.datatable.selectedItems) {
        pay_amount_sum += factor.factor_price_sum
      }
      return pay_amount_sum
    },
    title() {
      return 'سفارش های در انتظار پرداخت'
    },
    headers() {
      return [];
    },
  },
  updated() {
  },
  created() {
  },
  methods: {
    verifyDiscountCode() {
      this.request({
        url: this.endpoint("subscriptions/verifyDiscountCode"),
        method: "post",
        data: {
          discount_code: this.discountCode,
          factor_amount: this.pay_amount,
        },
        success: (data) => {
          this.notify("کد تخفیف اعمال شد", "success");
          this.discountAmount = data.discount_amount;
        },
      });
    },

    getRemain() {
      if (this.payFromWallet) {
        return Math.max(0, this.afterDiscount() - this.user.wallet.balance);
      } else return this.afterDiscount();
    },
    afterDiscount() {
      return this.pay_amount - this.discountAmount
    },

    openPaymentDialog() {
      this.pay_amount = this.pay_amount_calculate
      this.paymentDialog = true
    },
    closePaymentDialog() {
      this.pay_amount = 0
      this.paymentDialog = false
    },
    payBusinessAffiliateFactors() {
      if (this.$refs.datatable.selectedItems.length == 0) {
        this.closePaymentDialog()
        Swal.fire({
          title: "نا موفق",
          text: "حداقل یک سفارش را انتخاب کنید",
          icon: "error",
          confirmButtonText: "ادامه",
          confirmButtonColor: '#e1ecf2',
        });

      } else {
        let request_data = {
          business_token: this.user.business_token,
          discount_code: this.discountCode,
          pay_from_wallet: this.payFromWallet,
          items: []
        }
        for (let factor of this.$refs.datatable.selectedItems) {
          request_data.items.push(
              {
                id: factor.id,
              }
          )
        }

        this.request({
          url: this.endpoint(`affiliate/factorPayment`),
          method: "post",
          data: request_data,
          success: data => {
            this.closePaymentDialog()
            this.successNotify()
            this.$refs.datatable.getDataFromApi()

          }
        })

      }

    },


  },
}
</script>

<style scoped lang="scss"></style>

